// src/pages/staff-management/components/StaffStats.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../components/AppIcon";

const StaffStats = ({ staff, onOpenTotal }) => {
  const { t } = useTranslation();
  const totalStaff = staff?.length || 0;
  const activeStaff =
    staff?.filter((member) => member?.status === "active")?.length || 0;
  const onLeaveStaff =
    staff?.filter((member) => member?.status === "on_leave")?.length || 0;
  const inactiveStaff =
    staff?.filter((member) => member?.status === "inactive")?.length || 0;

  // numărăm pe baza codului de rol intern: owner / director / reception / employee
  const roleCounts = staff?.reduce(
    (acc, member) => {
      const code = member?.roleCode || member?.role;

      switch (code) {
        case "owner":
        case "Owner (Business)":
          acc.owner += 1;
          break;
        case "director":
        case "Director de sucursală":
          acc.director += 1;
          break;
        case "reception":
        case "Recepționer":
          acc.reception += 1;
          break;
        case "employee":
        case "Angajat":
        default:
          acc.employee += 1;
          break;
      }

      return acc;
    },
    { owner: 0, director: 0, reception: 0, employee: 0 }
  );

  const stats = [
    {
      key: "total",
      title: t("staff.stats.total"),
      value: totalStaff,
      icon: "Users",
      color: "bg-primary",
      textColor: "text-primary",
    },
    {
      key: "active",
      title: t("staff.stats.active"),
      value: activeStaff,
      icon: "UserCheck",
      color: "bg-success",
      textColor: "text-success",
    },
    {
      key: "onLeave",
      title: t("staff.stats.onLeave"),
      value: onLeaveStaff,
      icon: "Calendar",
      color: "bg-warning",
      textColor: "text-warning",
    },
    {
      key: "inactive",
      title: t("staff.stats.inactive"),
      value: inactiveStaff,
      icon: "UserX",
      color: "bg-error",
      textColor: "text-error",
    },
  ];

  const roleRows = [
    { key: "owner", label: t("staff.roleLabels.owner") },
    { key: "director", label: t("staff.roleLabels.director") },
    { key: "reception", label: t("staff.roleLabels.reception") },
    { key: "employee", label: t("staff.roleLabels.employee") },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className={`bg-background rounded-lg border border-border p-6 hover-elevate ${
            stat?.key === "total" && onOpenTotal ? "cursor-pointer" : ""
          }`}
          role={stat?.key === "total" && onOpenTotal ? "button" : undefined}
          tabIndex={stat?.key === "total" && onOpenTotal ? 0 : undefined}
          onClick={() => {
            if (stat?.key === "total") onOpenTotal?.();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              if (stat?.key === "total") onOpenTotal?.();
            }
          }}
        >
          <div className="flex items-center justify-between gap-3">
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-text-secondary mb-1 break-words">
                {stat?.title}
              </p>
              <p className="text-3xl font-bold text-foreground">
                {stat?.value}
              </p>

              {stat?.key === "total" && (
                <div className="mt-2 space-y-1">
                  {roleRows
                    .filter((r) => roleCounts?.[r.key] > 0)
                    .map((r) => (
                      <div
                        key={r.key}
                        className="flex items-start justify-between gap-2 text-xs"
                      >
                        <span className="text-text-secondary min-w-0 break-words">
                          {r.label}:
                        </span>
                        <span className="font-medium text-foreground shrink-0">
                          {roleCounts[r.key]}
                        </span>
                      </div>
                    ))}
                </div>
              )}
            </div>
            <div
              className={`w-12 h-12 shrink-0 ${stat?.color} rounded-lg flex items-center justify-center`}
            >
              <Icon name={stat?.icon} size={24} color="white" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StaffStats;
